import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  compose,
  branch,
  mapProps,
  lifecycle,
} from 'recompose'

import { authenticateByToken } from 'actions/Auth'

export const mapStateToProps = (state) => {
  const {
    isAuthenticating = false,
    currentUser = null,
  } = state.root.auth || {}

  return {
    isAuthenticating,
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  authenticateByToken: bindActionCreators(authenticateByToken, dispatch),
})

const privateComponent = (SecureComponent) => {
  const isAuthenticated = ({ isAuthenticating, currentUser }) => (
    !isAuthenticating && !!currentUser
  )

  return compose(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
    lifecycle({
      componentDidMount() {
        !isAuthenticated(this.props) && this.props.authenticateByToken()
      },
    }),
    mapProps(
      props => {
        const { authenticateByToken, ...rest } = props;
        return rest; 
      },
    ),
    branch(
      isAuthenticated,
      value => value,
    ),
  )(SecureComponent)
}

export default privateComponent
